import * as React from 'react';
var useMediaQuery = function (mediaQuery) {
    var _a = React.useState(!!window.matchMedia(mediaQuery).matches), isVerified = _a[0], setIsVerified = _a[1];
    React.useEffect(function () {
        var mediaQueryList = window.matchMedia(mediaQuery);
        var documentChangeHandler = function () { return setIsVerified(!!mediaQueryList.matches); };
        try {
            mediaQueryList.addEventListener('change', documentChangeHandler);
        }
        catch (e) {
            mediaQueryList.addListener(documentChangeHandler);
        }
        documentChangeHandler();
        return function () {
            try {
                mediaQueryList.removeEventListener('change', documentChangeHandler);
            }
            catch (e) {
                mediaQueryList.removeListener(documentChangeHandler);
            }
        };
    }, [mediaQuery]);
    return isVerified;
};
export default useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map